module.exports = __webpack_public_path__ + "media/images/cloud-check-outline-b25b7544d366b56cf791b6da70443698.svg";